import React from 'react';

import { Input, Text, Textarea } from '@components/common';
import { Label } from '@components/fields';

interface DisqualificationPageFormProps extends React.FormHTMLAttributes<HTMLFormElement> {
  disqualificationPageTitle: string;
  setDisqualificationPageTitle: (value: string) => void;
  disqualificationPageContent: string;
  setDisqualificationPageContent: (value: string) => void;
  disqualificationPageTitleError: boolean | null;
  disqualificationPageContentError: boolean | null;
  isEditPage?: boolean;
}

const DisqualificationPageForm: React.FC<DisqualificationPageFormProps> = ({
  disqualificationPageTitle,
  setDisqualificationPageTitle,
  disqualificationPageContent,
  setDisqualificationPageContent,
  disqualificationPageTitleError,
  disqualificationPageContentError,
  isEditPage,
  ...props
}) => {
  return (
    <form className='my-4 rounded bg-gray-50 p-3' aria-labelledby='disqualification-heading' role='group' {...props}>
      <fieldset>
        <Text h={`${isEditPage ? '600' : '400'}`} bold as='h3' id='disqualification-heading'>
          Disqualification page
        </Text>
        <Label className='h-300 mb-1 mt-4 font-bold' labelFor='disqualification-page-title'>
          Title
        </Label>
        <Input
          className='w-full'
          id='disqualification-page-title'
          data-testid='disqualification-page-title'
          aria-invalid={!!disqualificationPageTitleError}
          error={!!disqualificationPageTitleError}
          value={disqualificationPageTitle}
          onChange={setDisqualificationPageTitle}
        />
        {disqualificationPageTitleError && (
          <Text h='200' color='red-600' className='mt-1'>
            Please enter a title
          </Text>
        )}
        <Label className='h-300 mb-1 mt-4 font-bold' labelFor='disqualification-page-description'>
          Content
        </Label>
        <Textarea
          id='disqualification-page-description'
          data-testid='disqualification-page-content'
          aria-invalid={!!disqualificationPageContentError}
          error={!!disqualificationPageContentError}
          value={disqualificationPageContent}
          onChange={setDisqualificationPageContent}
        />
        {disqualificationPageContentError && (
          <Text h='200' color='red-600' className='mt-1'>
            Please enter a description
          </Text>
        )}
      </fieldset>
    </form>
  );
};

export default DisqualificationPageForm;
